import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { transducersData } from '../../data/transducersData';

const SimpleLiveScopePlusLVS34 = () => {
  // Get the product data directly from transducersData
  const productId = "livescope-plus-lvs34";
  const productData = transducersData.find(item => item.id === productId);
  
  console.log('SimpleLiveScopePlusLVS34 - Direct Import - Product Data:', productData);
  console.log('SimpleLiveScopePlusLVS34 - Direct Import - Image URL:', productData?.image);
  
  // Use a direct image URL if we can't find one
  const imageUrl = productData?.image || "/images/transducers/livescopeplus.jpg";
  
  return (
    <SimpleProductPage 
      specificProductId="livescope-plus-lvs34"
      productName="Garmin LiveScope Plus LVS34"
      productImage={imageUrl}
    />
  );
};

export default SimpleLiveScopePlusLVS34; 